import { render, staticRenderFns } from "./EditMedia.vue?vue&type=template&id=275e1004&scoped=true&"
import script from "./EditMedia.vue?vue&type=script&lang=js&"
export * from "./EditMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275e1004",
  null
  
)

export default component.exports